module.exports = __webpack_public_path__ + "media/explosion.b450a541.mp3";